module.exports = __webpack_public_path__ + "media/images/pages/i-belong/student_events-d47626d4448a6e0c7a0684aa92f6c449.svg";